import { useState } from "react";
import "./SurveyModal.css";
import survey1 from "../../assets/survey/survey1.svg";
import survey2 from "../../assets/survey/survey2.svg";
import survey3 from "../../assets/survey/survey3.svg";
import survey4 from "../../assets/survey/survey4.svg";
import survey5 from "../../assets/survey/survey5.svg";

function EmoticonsView  ({title, question,isEng, saveAnswer}) {
    
    const [selectedEmoticon, setSelectedEmoticon] = useState(null);

    const answers = question?.answers || [];

    const surveyImages = [survey5, survey3, survey1];
    
    const handleEmoticonClick = (index, question) => {
      const answerValue = question.answers[index];
      setSelectedEmoticon(index);
      saveAnswer(question.QuestionID, 1, answerValue);
    }
  
      return(
        <>
        <div className="survey_common_style_start_col">
          <div className="survey_margin_top_and_bottom">
            <div className="survey_margin_bottom" style={{ textAlign: 'center',padding:'20px' }} ><span>
              {title}
              <span style={{ color: "#ED152B" }}>*</span>
            </span></div>
            <div className="survey_reactions survey_common_style_start">
              {surveyImages.map((imgSrc, index) => (
                <div className="survey_common_style_center_col" key={index}>
                  <div onClick={() => handleEmoticonClick(index,question)} className={(index) === selectedEmoticon ? "survey_selected_container" : "survey_not_selected_container"} key={index}>
                    <img className="survey_emoticons_size" src={imgSrc} alt={`survey-${index + 1}`} />
                  </div>
                  <div className="survey_emoticon_fontsize">{!isEng ? answers[index]?.AnswerTitleA : answers[index]?.AnswerTitleE}</div>
      
                </div>
              ))}
            </div>
          </div>
          
        </div>
      </>
      )
      
  }

  export default EmoticonsView